module.exports = __webpack_public_path__ + "img/trendsetter.67a33675.jpg";